import React from "react";
import { Flex } from "@chakra-ui/react";
import { AccordionItem } from "components";
import { Notes, PreAnesthetic, Diagnostic } from "./components";

const Exam: React.FC = () => (
  <Flex mt={6} direction="column" gap={6}>
    <AccordionItem title="Notes, Treatments and Diagnostics Requested">
      <Notes />
    </AccordionItem>

    <AccordionItem title="Pre-anesthetic Exam and Vitals">
      <PreAnesthetic />
    </AccordionItem>

    <AccordionItem title="Diagnostic Testing">
      <Diagnostic />
    </AccordionItem>
  </Flex>
);

export default Exam;
